/**
 * Created by DELL on 2018/7/5.
 */
import React from "react";
import { Layout, Menu, message, Dropdown } from "antd";
import { withRouter } from "react-router-dom";
import common from "../public/common";
import AppRoute from "../routes/app-route";
import {
  switchTabBarIndex,
  clearCookie,
  clearCookieNew,
  getCookie,
  getCookieNew,
  setCookie,
  getParmUrl,
  getParmUrlNew,
} from "../public/utils";
import { ajaxApi, axiosPost, newAjaxApi } from "../server/index";
import ChangePassWord from "@/compenents/changepassword/changepassword";
import {
  SettingOutlined,
  EditOutlined,
  LogoutOutlined,
  LockOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  FolderOpenOutlined,
  FileTextOutlined,
  DownOutlined,
} from "@ant-design/icons";
import { selectItem, selectLable, selectNavigat } from "./SelectItem";
const { Header, Sider, Content } = Layout;
const { SubMenu } = Menu;
const eurekaUrl = common.eurekaUrlDic;
class MainPageLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      iframeHeight: "",
      iframeUrls: "",
      // 获取菜单数据
      collapsed: false,
      name: "",
      current: 1,
      menuUnitDatas: [],
      secondMenu: [],
      noChangeSecondMenu: [],
      showIframe: false,
      loading: false,
      isShowAll: true,
      collapsed: false,
      lefth: 200,
      inputKeyWord: "",
      progressValue: 30,
      selectedKeys: [],
      openKeys: [],
      changeWord: false,
      isShowmenus: true,
      isClick: false,
      identity: "",
      items: [],
      enterpriseList: [],
      supplierCompanyList: [],
      companyLabel: "",
    };
  }
  componentDidMount() {
    this.fullScreenChange();
    if (getParmUrl("unit")) {
      this.setState({
        changeWord: true,
        unitPassword: true,
      });
    }
    if (getParmUrl("ishidemenu")) {
      this.setState({
        isShowmenus: false,
      });
    }
    let _arr = document.cookie.match(/[^ =;]+(?=\=)/g);
    if (_arr) {
      for (let i = 0; i < _arr.length; i++) {
        clearCookie(_arr[i]);
      }
    }

    this.setState({
      iframeHeight: document.body.clientHeight - 120,
    });
    if (window.localStorage.getItem("currentMenusSCS")) {
      this.setState({
        current: window.localStorage.getItem("currentMenusSCS") * 1,
      });
    }
    let name = getCookie("login_username");
    this.setState({
      name: name,
    });

    if (!getParmUrl("opration")) {
      this.getRuleId();
      this.getMenus();
    }
    this.getEnterPrise();
    window.addEventListener("scroll", this.handleScroll);
    if (window.location.pathname == "/") {
      this.props.history.push("/main/home");
    }
    document.addEventListener(
      "visibilitychange",
      () => {
        //浏览器tab切换监听事件
        if (document.visibilityState == "visible") {
          //状态判断：显示（切换到当前页面）
          //获取当前租户的名字
          if (
            this.state.identity != getCookie("business_name") ||
            this.state.companyLabel != getCookieNew("supplier_company_name")
          ) {
            const item = (
              this.state.enterpriseList.filter(
                (e) =>
                  e.supplier_company_code ==
                  getCookieNew("supplier_company_code")
              ) || []
            ).find((sup) => sup.business_name == getCookie("business_name"));
            console.log(item);
            if (item) {
              const sid = item.register_sid;
              const type = item.review_status;
              if (type != "100") {
                const url =
                  window.location.origin +
                  "/main/suppliersettlement/supplierinformationentry/new-supplier-information-entry?opration=perfection"
                if (item.status === "101") {
                  //还未填写信息，前往完善信息页面
                  if (window.location.href != url) {
                    window.location.href = url;
                  }
                }
                if (
                  ["201", "202", "203", "204", "205", "206", "207"].includes(
                    type
                  )
                ) {
                  //去基础信息填写页面
                  if (window.location.href != url) {
                    window.location.href = url;
                  }
                }
                if (["301", "302", "303", "304", "305"].includes(type)) {
                  const quaUrl =
                    window.location.origin +
                    "/main/suppliersettlement/compliancecertification/index?opration=perfection&&sid=" +
                    sid;
                  if (window.location.href != quaUrl) {
                    window.location.href = quaUrl;
                  }
                }
              } else {
                window.location = common.scsWebUrl;
              }
            } else {
              //如果地址一样就不要刷新了
              const url =
                window.location.origin +
                "/main/suppliersettlement/supplierinformationentry/new-supplier-information-entry?opration=perfection";
              if (window.location.href != url) {
                window.location.href = url;
              }
            }
          }
        }
      },
      false
    );
  }

  fullScreenChange = () => {
    document.addEventListener("fullscreenchange", this.handleFullScreen);
  };
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleFullScreen = () => {
    if (document.fullscreenElement !== null) {
      // 打开全屏
      let element = document.getElementById("scsContent");
      element && element.classList.add("scroll");
    } else {
      // 关闭全屏
      let element = document.getElementById("scsContent");
      element && element.classList.remove("scroll");
    }
  };

  handleScroll = (event) => {
    let scrollTop = document.documentElement.scrollTop; // 滚动条滚动高度
    this.setState({
      iframeHeight: document.body.clientHeight + scrollTop - 120,
    });
  };
  //点击左上角主体
  onClick = ({ item, key }) => {
    if (key && this.state.items) {
      const data = this.state.items.find((ele) => ele.business_id == key);
      if (data && data.business_name) {
        setCookie("business_name", data.business_name, 3);
      }
    }
    //如果是申请入驻，清除businessId，跳转申请页面
    //如果不是申请入驻，写入新businessId，根据status跳转不同页面
    if (key === "申请入驻") {
      clearCookieNew("business_name");
      clearCookieNew("po_subject_code");
      clearCookieNew("supplier_code");
      localStorage.removeItem("accountInfo");
      selectNavigat(null, null, "sigo"); //跳转
    } else {
      const status = item.props.review_status || null; //拿到status
      const register_sid = item.props.register_sid || null;
      const businessId = item.props.request_business_id || null;
      if (status == 100) {
        localStorage.setItem(
          "accountInfo",
          JSON.stringify(this.state.items.find((ele) => ele.business_id == key))
        );
      }
      setCookie("sid", register_sid, 3); //写入新id
      setCookie("business_name", item.props.business_name, 3);
      setCookie("supplier_code", item.props.supplier_code || "", 3);
      setCookie("supplier_company_code", item.props.supplier_company_code, 3); //写入新id
      setCookie("supplier_company_name", item.props.supplier_company_name, 3);
      setCookie("po_subject_code", item.props.po_subject_code, 3);
      selectNavigat(status, register_sid, businessId); //跳转
    }
  };
  //点击右上角公司
  companyClick = ({ item, key }) => {
    const { enterpriseList, supplierCompanyList } = this.state;
    const items = enterpriseList.find(
      (item) => item.supplier_company_code === key
    );
    this.setState({
      companyLabel: supplierCompanyList.find((item) => item.key === key)
        .supplier_company_name,
    });
    const status = items.review_status || null; //拿到status
    const register_sid = items.register_sid || null;
    const businessId = items.request_business_id || null;
    if (status == 100) {
      localStorage.setItem("accountInfo", JSON.stringify(items));
    }
    setCookie("sid", register_sid, 3); //写入新id
    setCookie("business_name", items.business_name, 3);
    setCookie("supplier_code", items.supplier_code || "", 3);
    setCookie("supplier_company_code", items.supplier_company_code, 3); //写入新id
    setCookie("supplier_company_name", items.supplier_company_name, 3);
    setCookie("po_subject_code", items.po_subject_code, 3);
    selectNavigat(status, register_sid, businessId); //跳转
  };
  //获取当前用户的所属集团
  getEnterPrise = async () => {
    //如果用户第一次登录，无accountId
    if (!getCookieNew("accountId")) {
      return;
    }
    let data = await newAjaxApi({
      url: common.eurekaUrlDic + "/account/base-info/query",
      params: {
        account_id: getCookieNew("accountId"),
      },
      ContentType: "application/json;charset=UTF-8",
    });
    if (data.status == 200) {
      const items = await selectItem(
        data.data.account_enterprise_list.filter(
          (e) =>
            e.supplier_company_code == getCookieNew("supplier_company_code")
        )
      );
      this.setState({
        items: items,
        enterpriseList: data.data.account_enterprise_list || [],
        supplierCompanyList:
          data.data.account_supplier_company_list.map((e) => {
            return {
              ...e,
              key: e.supplier_company_code,
              label: e.supplier_company_name,
            };
          }) || [],
        identity: selectLable(items),
        companyLabel:
          data.data.account_supplier_company_list.find(
            (e) =>
              e.supplier_company_code == getCookieNew("supplier_company_code")
          ).supplier_company_name || "",
      });
    }
  };
  // 获取当前用户的roleid
  getRuleId = async () => {
    const res = await axiosPost(eurekaUrl + "/permission/getpermission", {
      user_id: getCookieNew("accountId") ? parseInt(getCookieNew("accountId")) : null,
      role_type: "system_and_supplier",
      supplier_code: getCookieNew("supplier_code") || "",
      po_subject_code: getCookieNew("po_subject_code") || "",
      supplier_company_code: getCookieNew("supplier_company_code") || ""
    });
    if (res.status === 200 && res.data.permissionlist) {
      setCookie("scsruleidarr", JSON.stringify(res.data.permissionlist), 3);
    }
  };
  // 获取所有菜单地址
  getMenus = async () => {
    const res = await axiosPost(eurekaUrl + "/permission/getmenu", {
      accountId: getCookieNew("accountId") ? parseInt(getCookieNew("accountId")) : null,
      roleType: "system_and_supplier",
      supplierCode: getCookieNew("supplier_code") || "",
      poSubjectCode: getCookieNew("po_subject_code") || "",
      supplierCompanyCode: getCookieNew("supplier_company_code") || ""
    });
    if (res.status === 200 && res.data) {
      this.setState(
        {
          menuUnitDatas: res.data.menulist,
        },
        () => {
          if (getParmUrlNew("backUrl")) {
            this.fistMenuChange(
              "",
              this.state.current - 1,
              true,
              true,
              getParmUrlNew("backUrl")
            );
          } else {
            this.fistMenuChange(
              "",
              this.state.current - 1,
              true,
              true,
              res.data.menulist[0].url
            );
          }
        }
      );
    }
  };
  // 针对erp系统后台 首次点击一级菜单不跟新路由问题
  refreshRoute = (url) => {
    let _path = url;
    let _arr = this.state.menuUnitDatas;
    for (let i in _arr) {
      let _child = _arr[i].children;
      for (let k in _child) {
        if (_path === _child[k].url) {
          this.setState({
            secondMenu: _child,
            current: Number(i) + Number(1),
          });
          let _num = Number(i) + Number(1);
          window.localStorage.setItem("currentMenusSCS", _num);
        } else {
          for (let j in _child[k].children) {
            if (_child[k].children[j].url === _path) {
              this.setState({
                secondMenu: _child,
                current: Number(i) + Number(1),
              });
              let _num = Number(i) + Number(1);
              window.localStorage.setItem("currentMenusSCS", _num);
            } else {
            }
          }
        }
      }
    }
  };
  toggleCollapsed = (e) => {
    this.setState(
      {
        collapsed: !this.state.collapsed,
      },
      () => {
        if (this.state.collapsed === false) {
          this.setState({
            lefth: 200,
          });
        } else {
          this.setState({
            lefth: 78,
          });
        }
      }
    );
  };
  ClearAndLogin = () => {
    const keyList = [
      "supplier_company_code",
      "po_subject_code",
      "phone",
      "business_id",
      "businessId",
      "business_name",
      "adminName",
      "userName",
      "businessId",
      "accountId",
      "sid",
      "scs_token",
    ];
    // clearCookieNew("adminName");
    // clearCookieNew("userName");
    // clearCookieNew("businessId");
    // clearCookieNew("accountId");
    // clearCookieNew("sid");
    // clearCookieNew("scs_token");
    keyList.forEach((key) => {
      clearCookieNew(key);
    });
    localStorage.removeItem("accountInfo");
    window.localStorage.clear();
    this.props.history.push("/login" + window.location.search);
  };
  // iframe url变化
  iframeUrlChange = (e) => {
    if (_url !== e) {
      window.location.href =
        window.location.href.split("#backUrl=")[0] + "#backUrl=" + e;
    }
    let _url = getParmUrlNew("backUrl");
    if (_url) {
      this.menuShow(_url);
    } else {
      let _urlOrigin = this.props.location.pathname;
      this.menuShow(_urlOrigin);
    }
  };
  // 切换地址
  menuUrlChange = (urls) => {
    this.setState({
      iframeUrls: urls,
    });
  };
  // 一级菜单改变
  fistMenuChange = (e, index, status, isfirst, item) => {
    // this.props.history.push('/')
    this.setState({
      inputKeyWord: "",
    });
    if (item && item.url) {
      if (this.state.iframeUrls === item.url) {
        this.setState({
          current: index + 1,
          secondMenu: [],
        });
        window.localStorage.setItem("currentMenusSCS", index + 1);
        return false;
      }
      this.setState({
        progressValue: 50,
        loading: true,
        iframeUrls: item.url,
        showIframe: true,
        current: index + 1,
        secondMenu: [],
      });
      window.localStorage.setItem("currentMenusSCS", index + 1);
      if (item.children.length) {
        this.setState({
          secondMenu: this.state.menuUnitDatas[index].children,
        });
        this.setState({
          current: index + 1,
        });
        let _num = Number(index) + Number(1);
        window.localStorage.setItem("currentMenusSCS", _num);
      }
    } else {
      this.setState({
        secondMenu: this.state.menuUnitDatas[index].children,
      });
      if (status) {
        this.setState(
          {
            secondMenu: this.state.menuUnitDatas[index].children,
          },
          () => {
            let _url = this.props.location.pathname;
            this.menuShow(_url);
          }
        );
        if (typeof item === "string") {
          this.setState({
            current: index + 1,
            showIframe: true,
            progressValue: 50,
            iframeUrls: isfirst ? item : null,
          });
        } else {
          if (item) {
            this.props.history.push("/");
          }

          this.setState({
            current: index + 1,
            showIframe: false,
            iframeUrls: "",
            progressValue: 50,
            iframeUrls: isfirst ? item : null,
          });
        }
        let _num = Number(index) + Number(1);
        window.localStorage.setItem("currentMenusSCS", _num);
        if (item) {
          this.refreshRoute(item);
        }
      } else {
        this.props.history.push("/main/emptyPage/emptyPage");
        this.setState({
          current: index + 1,
          showIframe: false,
        });
      }
    }
  };
  // 地址发生改变
  changeIframeurl = (e, url, iscan, isroute) => {
    console.log(url);
    this.setState({
      progressValue: 50,
      loading: true,
    });
    if (!url) {
      message.error("您访问的地址不存在，或已迁移！");
      return false;
    }
    this.menuShow(url);
    if (iscan) {
      if (isroute) {
        this.setState({
          showIframe: false,
        });

        this.props.history.push(url);
      } else {
        this.setState({
          iframeUrls: url,
          showIframe: true,
        });
      }
    } else {
      this.setState({
        showIframe: false,
      });
      this.props.history.push("/main/emptyPage/emptyPage");
    }
  };
  // 二级菜单点击
  secondMenuChange = (e, iscan) => {
    if (!iscan) {
      this.setState({
        showIframe: false,
      });
      this.props.history.push("/main/emptyPage/emptyPage");
      return false;
    }
  };
  // 是否查看全部菜单
  switchChange = (checked) => {
    this.setState({
      isShowAll: checked,
    });
  };
  // 菜单搜索
  seachMenus = (e) => {
    this.setState({
      inputKeyWord: e.target.value,
    });
    if (e.target.value) {
      let keyWord = e.target.value;
      let secondMenuChange = JSON.parse(
        JSON.stringify(this.state.menuUnitDatas)
      );
      let newArr = [];
      for (let i = 0; i < secondMenuChange.length; i++) {
        if (secondMenuChange[i].children.length) {
          for (let a = 0; a < secondMenuChange[i].children.length; a++) {
            if (secondMenuChange[i].children[a].children.length) {
              for (
                let b = 0;
                b < secondMenuChange[i].children[a].children.length;
                b++
              ) {
                if (
                  secondMenuChange[i].children[a].children[b].menuname.indexOf(
                    keyWord
                  ) > -1
                ) {
                  secondMenuChange[i].children[a].children[b].current = i;
                  secondMenuChange[i].children[a].children[b].upUpName =
                    secondMenuChange[i].menuname;
                  secondMenuChange[i].children[a].children[b].upName =
                    secondMenuChange[i].children[a].menuname;
                  newArr.push(secondMenuChange[i].children[a].children[b]);
                }
              }
            } else {
              if (
                secondMenuChange[i].children[a].menuname.indexOf(keyWord) > -1
              ) {
                secondMenuChange[i].children[a].current = i;
                secondMenuChange[i].children[a].upUpName =
                  secondMenuChange[i].menuname;
                newArr.push(secondMenuChange[i].children[a]);
              }
            }
          }
        }
      }
      this.setState({
        noChangeSecondMenu: newArr,
      });
    } else {
      this.setState({
        noChangeSecondMenu: [],
      });
    }
  };

  otherUrlFilter = (urls) => {
    let newUrl;
    newUrl = urls;
    return newUrl;
  };
  menuShow = (url) => {
    let _path = url;
    let _pathArr = this.state.secondMenu;
    let _select = [];
    let _open = [];
    if (_pathArr) {
      for (let i in _pathArr) {
        if (_pathArr[i].url === _path) {
          let _arr = _pathArr[i].children;
          if (_arr.length > 0) {
            for (let k in _arr) {
              if (_arr[k].url === _path) {
                _select.push(`${_arr[k].menuid}`);
                _open.push(`${_pathArr[i].menuid}`);
                this.setState(
                  {
                    selectedKeys: _select,
                    openKeys: _open,
                  },
                  () => {}
                );
              }
            }
          } else {
            _select.push(`${_pathArr[i].menuid}`);
            this.setState(
              {
                selectedKeys: _select,
              },
              () => {}
            );
          }
        } else {
          let _arr = _pathArr[i].children;
          for (let k in _arr) {
            if (_arr[k].url === _path) {
              _select.push(`${_arr[k].menuid}`);
              _open.push(`${_pathArr[i].menuid}`);
              this.setState(
                {
                  selectedKeys: _select,
                  openKeys: _open,
                },
                () => {}
              );
            }
          }
        }
      }
    }
  };
  onOpenChange = (openKeys) => {
    this.setState({
      openKeys: openKeys,
    });
  };
  // 修改密码弹框
  passwordChange = (type) => {
    this.setState(
      {
        changeWord: !this.state.changeWord,
        isClick: type || false,
      },
      () => {
        console.log(this.state.changeWord);
      }
    );
  };

  goSafe = () => {
    window.location.href = "/main/login/setting";
  };
  render() {
    const { supplierCompanyList, companyLabel, selectedKeys, openKeys } =
      this.state;
    const quickMenuItems = [
      {
        key: "change-password",
        label: (
          <span onClick={() => this.passwordChange(1)}>
            <EditOutlined style={{ marginRight: "12px" }} /> 修改密码
          </span>
        ),
      },
      {
        key: "security-settings",
        label: (
          <span onClick={this.goSafe}>
            <SettingOutlined style={{ marginRight: "12px" }} />
            安全设置
          </span>
        ),
      },
      {
        key: "logout",
        label: (
          <span onClick={this.ClearAndLogin}>
            <LogoutOutlined style={{ marginRight: "12px" }} /> 退出登录
          </span>
        ),
      },
    ];
    return (
      <Layout>
        <ChangePassWord
          changePasswordStatus={this.state.changeWord}
          isClick={this.state.isClick}
          showMes={this.state.unitPassword}
          passwordChange={this.passwordChange}
        />
        {this.state.isShowmenus ? (
          <Header className="header">
            <span className="logotitle">
              <div className="logotitle_title">
                供应商协同系统SCS{this.state.passwordChange}
              </div>
              {this.state.items.length > 0 && (
                <Dropdown
                  placement="bottom"
                  menu={{ items: this.state.items, onClick: this.onClick }}
                >
                  <div
                    onClick={(e) => e.preventDefault()}
                    className="logotitle_text"
                  >
                    {this.state.identity} <DownOutlined />
                  </div>
                </Dropdown>
              )}
            </span>
            {/* <span>123</span> */}
            {this.state.menuUnitDatas.length ? (
              //  一级菜单
              <Menu
                theme="dark"
                mode="horizontal"
                style={{ lineHeight: "64px", height: "64px" }}
                selectedKeys={[`${this.state.current}`]}
              >
                {this.state.menuUnitDatas.map((item, index) => {
                  if (this.state.isShowAll) {
                    return (
                      <Menu.Item
                        key={index + 1}
                        onClick={(e) =>
                          this.fistMenuChange(e, index, item.iscan, "", item)
                        }
                      >
                        {!item.iscan ? (
                          <LockOutlined
                            style={{ color: "white", fontSize: "16px" }}
                          />
                        ) : null}
                        {item.menuname}
                      </Menu.Item>
                    );
                  } else {
                    if (item.iscan) {
                      return (
                        <Menu.Item
                          key={index + 1}
                          onClick={(e) =>
                            this.fistMenuChange(e, index, item.iscan, "", item)
                          }
                        >
                          {!item.iscan ? (
                            <LockOutlined
                              style={{ color: "#95a0a9", fontSize: "16px" }}
                            />
                          ) : null}
                          {item.menuname}
                        </Menu.Item>
                      );
                    }
                  }
                })}
              </Menu>
            ) : null}
            <span className="logotitle_" style={{ color: "#a5adb5!important" }}>
              <Dropdown
                placement="bottom"
                menu={{
                  items: supplierCompanyList,
                  onClick: this.companyClick,
                }}
              >
                <div
                  onClick={(e) => e.preventDefault()}
                  className="logotitle_text"
                >
                  {companyLabel}
                  <DownOutlined />
                </div>
              </Dropdown>
              <Dropdown menu={{ items: quickMenuItems }} placement="bottom">
                <span>
                  <span style={{ paddingRight: "12px", marginLeft: "16px" }}>
                    快捷
                  </span>
                  <DownOutlined
                    className="trigger"
                    style={{ marginRight: "24px" }}
                  />
                </span>
              </Dropdown>
            </span>
          </Header>
        ) : null}

        <Layout
          style={{
            padding: 24,
            margin: 24,
            marginLeft: "12px",
            marginRight: "12px",
            position: "relative",
            paddingBottom: 0,
          }}
        >
          {this.state.isShowmenus ? (
            <Sider
              collapsed={this.state.collapsed}
              width={this.state.secondMenu.length ? 280 : 0}
              style={{ background: "#fff", borderRight: "1px solid #e8e8e8" }}
            >
              {/* <Button type="" > */}
              {this.state.collapsed ? (
                <MenuUnfoldOutlined
                  onClick={this.toggleCollapsed}
                  style={{
                    marginBottom: "16px",
                    marginLeft: "12px",
                    fontSize: "25px",
                    marginTop: "16px",
                    cursor: "pointer",
                  }}
                />
              ) : (
                <MenuFoldOutlined
                  onClick={this.toggleCollapsed}
                  style={{
                    marginBottom: "16px",
                    marginLeft: "12px",
                    fontSize: "25px",
                    marginTop: "16px",
                    cursor: "pointer",
                  }}
                />
              )}

              <br />
              {/* 二级菜单 */}

              {this.state.secondMenu.length ? (
                <Menu
                  mode="inline"
                  selectedKeys={selectedKeys}
                  openKeys={openKeys}
                  onOpenChange={this.onOpenChange}
                  style={{
                    border: "none",
                    width: this.state.collapsed ? "78px" : "",
                  }}
                >
                  {this.state.secondMenu.map((item2, index2) => {
                    if (item2.children.length) {
                      if (
                        this.state.isShowAll ||
                        (!this.state.isShowAll && item2.iscan)
                      ) {
                        return (
                          <SubMenu
                            key={item2.menuid}
                            onTitleClick={(e) =>
                              this.secondMenuChange(e, item2.iscan)
                            }
                            title={
                              <span>
                                {!item2.iscan ? (
                                  <LockOutlined
                                    style={{
                                      color: "#bfbfbf",
                                      fontSize: "16px",
                                    }}
                                  />
                                ) : (
                                  <FolderOpenOutlined />
                                )}
                                <span
                                  style={{
                                    color: !item2.iscan ? "#bfbfbf" : "",
                                  }}
                                >
                                  {item2.menuname}
                                </span>
                              </span>
                            }
                          >
                            {
                              //  三级菜单
                              item2.children.map((item3, index3) => {
                                if (
                                  this.state.isShowAll ||
                                  (!this.state.isShowAll && item3.iscan)
                                ) {
                                  return (
                                    <Menu.Item
                                      key={item3.menuid}
                                      onClick={(e) =>
                                        this.changeIframeurl(
                                          e,
                                          item3.url,
                                          item3.iscan,
                                          item3.isroute
                                        )
                                      }
                                    >
                                      {" "}
                                      {!item3.iscan ? (
                                        <LockOutlined
                                          style={{
                                            color: "#bfbfbf",
                                            fontSize: "16px",
                                          }}
                                        />
                                      ) : (
                                        <FileTextOutlined />
                                      )}{" "}
                                      <span
                                        style={{
                                          color: !item3.iscan ? "#bfbfbf" : "",
                                        }}
                                        title={item3.menuname}
                                      >
                                        {item3.menuname}
                                      </span>
                                    </Menu.Item>
                                  );
                                }
                              })
                            }
                          </SubMenu>
                        );
                      }
                    } else {
                      // 只有二级菜单
                      if (
                        this.state.isShowAll ||
                        (!this.state.isShowAll && item2.iscan)
                      ) {
                        return (
                          <Menu.Item
                            key={item2.menuid}
                            onClick={(e) =>
                              this.changeIframeurl(
                                e,
                                item2.url,
                                item2.iscan,
                                item2.isroute
                              )
                            }
                          >
                            {!item2.iscan ? (
                              <LockOutlined
                                style={{ color: "#bfbfbf", fontSize: "16px" }}
                              />
                            ) : (
                              <FileTextOutlined />
                            )}
                            <span
                              style={{ color: !item2.iscan ? "#bfbfbf" : "" }}
                              title={item2.menuname}
                            >
                              {item2.menuname}
                            </span>
                          </Menu.Item>
                        );
                      }
                    }
                  })}
                </Menu>
              ) : null}
            </Sider>
          ) : null}
          <Layout style={{ padding: 24, background: "#fff" }} id="scsContent">
            <Content style={{ margin: 0, minHeight: 820, marginLeft: "8px" }}>
              {this.state.showIframe ? (
                <div>
                  <iframe
                    id="mainIframe"
                    name="mainIframe"
                    width="100%"
                    height={this.state.iframeHeight}
                    onLoad={() => this.iframeUrlChange(this.state.iframeUrls)}
                    src={this.state.iframeUrls}
                    frameBorder="0"
                    scrolling="auto"
                  ></iframe>
                </div>
              ) : (
                <AppRoute />
              )}
            </Content>
          </Layout>
        </Layout>
        {/* </Spin> */}
      </Layout>
    );
  }
}

export default withRouter(MainPageLayout);



// WEBPACK FOOTER //
// ./src/layout/main-page-layout.js